<script lang="ts">
  import { onMount } from 'svelte';
  import BlogCard from '../lib/BlogCard.svelte';
  import BackToHomeButton from '../components/BackToHomeButton.svelte';
  import BackToTopButton from '../components/BackToTopButton.svelte';
  import AnimatedBackground from '../lib/AnimatedBackground.svelte';
  import Footer from '../lib/Footer.svelte';
  
  const blogPosts = [
    {
      title: "Using Nugget MobileGestalt tweaks",
      excerpt: "Learn how to extract and modify the MobileGestalt plist file to enable restricted iOS features on unsupported devices.",
      date: "June 8, 2025",
      readTime: "3 min read",
      tags: ["iOS", "Tweaks", "MobileGestalt"],
      url: "/#/blog/using-nugget-mobilegestalt-tweaks"
    },
    {
      title: "Welcome to enkei64's portfolio!",
      excerpt: "An introduction to my portfolio on my website and how it was made.",
      date: "June 8, 2025",
      readTime: "2 min read",
      tags: ["Portfolio", "Development", "Introduction"],
      url: "/#/blog/welcome-to-enkei64-portfolio"
    }
  ];
  
  let mounted = false;
  
  onMount(() => {
    mounted = true;
    document.title = "enkei64 - Blog";
    
    window.scrollTo(0, 0);
  });
</script>

<AnimatedBackground />
<BackToHomeButton />

<main class="blog-list-page">
  <div class="container">
    <div class="page-header glass-card" class:animate={mounted}>
      <h1>Blog Articles</h1>
      <p>Thoughts, tutorials, and insights on development, iOS tweaks, and technology</p>
    </div>
    
    <div class="blog-grid" class:animate={mounted}>
      {#each blogPosts as post, index}
        <div class="blog-item" style="animation-delay: {index * 0.1}s">
          <BlogCard {...post} />
        </div>
      {/each}
    </div>
  </div>
</main>

<Footer />
<BackToTopButton />

<style>
  .blog-list-page {
    min-height: 100vh;
    padding: var(--spacing-2xl) 0;
  }
  
  .container {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 0 var(--spacing-lg);
  }
  
  .page-header {
    text-align: center;
    padding: var(--spacing-xl);
    margin-bottom: var(--spacing-2xl);
  }
  
  .page-header h1 {
    margin-bottom: var(--spacing-sm);
    font-size: 2.5rem;
  }
  
  .page-header p {
    font-size: 1.25rem;
    color: var(--text-secondary);
    max-width: 600px;
    margin: 0 auto;
  }
  
  .blog-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: var(--spacing-lg);
  }
  
  .blog-item {
    opacity: 0;
    transform: translateY(30px);
    animation: fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }
  
  .animate {
    animation: fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    opacity: 0;
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @media (max-width: 768px) {
    .blog-grid {
      grid-template-columns: 1fr;
    }
    
    .page-header {
      padding: var(--spacing-lg);
    }
  }
</style> 